import api from './api';

export const authService = {
  login: async (username, password) => {
    const response = await api.post('/autenticazione/auth/login/', { username, password });
    const { access, refresh, utente } = response.data;
    
    localStorage.setItem('accessToken', access);
    localStorage.setItem('refreshToken', refresh);
    localStorage.setItem('utente', JSON.stringify(utente));
    
    return utente;
  },

  logout: async () => {
    const refreshToken = localStorage.getItem('refreshToken');
    try {
      await api.post('/autenticazione/auth/logout/', { refresh: refreshToken });
    } catch (error) {
      console.error('Errore durante il logout:', error);
    }
    
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('utente');
  },

  getCurrentUser: () => {
    const utenteStr = localStorage.getItem('utente');
    return utenteStr ? JSON.parse(utenteStr) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('accessToken');
  },
};

export const abbonamentoService = {
  getMieiAbbonamenti: () => api.get('/abbonamenti/abbonamenti/miei_abbonamenti/'),
  getAbbonamento: (id) => api.get(`/abbonamenti/abbonamenti/${id}/`),
  validaQR: (token) => api.post('/abbonamenti/abbonamenti/valida_qr/', { token }),
  rigeneraQR: (id) => api.get(`/abbonamenti/abbonamenti/${id}/rigenera_qr/`),
};

export const anagraficheService = {
  getTitolari: () => api.get('/anagrafiche/titolari/'),
  getBeneficiari: () => api.get('/anagrafiche/beneficiari/'),
  createTitolare: (data) => api.post('/anagrafiche/titolari/', data),
  createBeneficiario: (data) => api.post('/anagrafiche/beneficiari/', data),
};

export const trasportiService = {
  getLinee: () => api.get('/trasporti/linee/'),
  getMezzi: () => api.get('/trasporti/mezzi/'),
  getCorse: () => api.get('/trasporti/corse/'),
  getMieCorse: () => api.get('/trasporti/corse/mie_corse/'),
};

export const controlliService = {
  getEventi: () => api.get('/controlli/eventi/'),
  getMieiControlli: () => api.get('/controlli/eventi/miei_controlli/'),
  getStatistiche: () => api.get('/controlli/eventi/statistiche/'),
};

